import React, { FC } from 'react'

import { IInventoryItem } from '@types'

import { InventorySlider, InventorySliderPreviewStyled, InventorySliderTitle } from './index.style'
import { InventorySliderImagePreview } from './InventorySliderImagePreview'

interface IInventorySelectedSliderProperties {
    collectionName: string
    items: IInventoryItem[]
    onChange: (index: number) => () => void
}

export const InventorySliderPreview: FC<IInventorySelectedSliderProperties> = properties => {
    return (
        <InventorySliderPreviewStyled>
            <InventorySliderTitle>
                {properties.items.length} NFTs from {properties.collectionName}
            </InventorySliderTitle>
            <InventorySlider>
                {properties.items.map((item, index) => {
                    return (
                        <InventorySliderImagePreview
                            key={`inventory-slider-${index}`}
                            image={item.preview.image}
                            onClick={properties.onChange(index)}
                        />
                    )
                })}
            </InventorySlider>
        </InventorySliderPreviewStyled>
    )
}
